import React from 'react'
import Style from './SepratePart.module.css'
const SepratePart = (props) => {
    return (
        <div className={Style.PartHolder} onClick={props.clickhandler}>
            <div className={Style.ImageHolder}><img src={props.ImgSrc} alt="taysuz" /></div>
            <p className={Style.TextPart}>{props.PartName}</p>
        </div>
    )
}

export default SepratePart
